// eslint-disable-next-line import/no-cycle
import GiftCardMessage from './GiftCardMessage';

const GiftCardItemData = (props) => {
  const { item } = props;

  if (item.type !== 'Gift Card') {
    return null;
  }
  if (!item.itemData) {
    return null;
  }
  if (!item.itemData.recipients) {
    return null;
  }
  if (item.itemData.recipients.length === 1) {
    return (
      <div className="c7-cart-items__title__variant">
        {item.itemData.recipients[0].email}
        <GiftCardMessage
          giftMessage={item.itemData.recipients[0].giftMessage}
        />
      </div>
    );
  }
  return (
    <>
      {item.itemData.recipients.map((recipient, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="c7-cart-items__title__variant">
          {index + 1}: {recipient.email}
          <GiftCardMessage giftMessage={recipient.giftMessage} />
        </div>
      ))}
    </>
  );
};

export default GiftCardItemData;
